import { Input, Tooltip } from 'components/common';
import UserFilter from './UserFilter';
import { FilterItem, FiltersContainer, FiltersRow } from '../styled';
import debounce from 'lodash.debounce';
import { useCallback, useEffect, useState } from 'react';
import DateFilter from './DateFilter';
import styled from 'styled-components';
import { formatNumber } from 'utils/number';

// const statusOptions = Object.entries(StatusPipConfig).map(([key, value]) => ({
//   label: value.text,
//   value: key,
// }));

// const typeOptions = Object.entries(ENRICHMENT_TYPE_LABELS).map(
//   ([key, value]) => ({
//     label: value,
//     value: key,
//   })
// );

const hexToRgb = hex =>
  hex
    .replace(/^#/, '')
    .match(/.{2}/g)
    .map(x => parseInt(x, 16));

const CreditToken = styled.div`
  display: flex;
  background-color: ${props => {
    const [r, g, b] = hexToRgb(props.theme.orange);
    return `rgba(${r}, ${g}, ${b}, 0.2)`;
  }};
  padding: 2px 6px;
  border-radius: 5px;
  border: 1px solid ${props => props.theme.orange};
  color: ${props => props.theme.orange};
  gap: 4px;
  font-size: 14px;
  margin-left: auto;
  margin-right: 15px;
  margin-bottom: 15px;
`;

const BoldSpan = styled.span`
  font-weight: bold;
`;

const getDaysUntilEndOfMonth = () => {
  const now = new Date();
  const lastDay = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 0)
  );
  const diffTime = lastDay - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export default function DataEnrichmentFilters({
  filters,
  user,
  updateFilters,
  credits,
}) {
  const [searchFilter, setSearchFilter] = useState(filters?.searchFilter || '');
  const [creditsRemaining, setCreditsRemaining] = useState(
    credits?.remainingCredits || null
  );

  useEffect(() => {
    if (credits) {
      setCreditsRemaining(credits.remainingCredits || 0);
    }
  }, [credits]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleInputChange = useCallback(
    debounce(value => {
      updateFilters({ ...filters, searchFilter: value, pageNumber: 0 });
    }, 300),
    [filters, updateFilters]
  );

  function updateSearchFilter(value) {
    setSearchFilter(value);
    handleInputChange(value);
  }

  const handleUserSelectionChange = values => {
    updateFilters({ ...filters, userIds: values, pageNumber: 0 });
  };

  function updateDateFilter(values) {
    updateFilters({
      ...filters,
      startDate: values[0],
      endDate: values[1],
      pageNumber: 0,
    });
  }

  // function updateStatus(values) {
  //   updateFilters({ ...filters, status: values, pageNumber: 0 });
  // }

  // function updateType(values) {
  //   updateFilters({ ...filters, type: values, pageNumber: 0 });
  // }

  const searchFilterItem = (
    <FilterItem>
      <Tooltip placement={'right'} title={searchFilter ? 'Search' : ''}>
        <Input
          onChange={updateSearchFilter}
          placeholder='Search'
          value={searchFilter}
          allowClear
        />
      </Tooltip>
    </FilterItem>
  );

  const userFilterItem = (
    <>
      {user.isUserManager && (
        <FilterItem>
          <UserFilter
            onChange={handleUserSelectionChange}
            userIds={filters?.userIds || []}
          />
        </FilterItem>
      )}
    </>
  );

  const dateFilterItem = (
    <DateFilter
      onChange={updateDateFilter}
      userId={user.userId}
      initialDateRange={
        filters?.startDate && filters?.endDate
          ? [filters.startDate, filters.endDate]
          : []
      }
    />
  );

  // const statusFilterItem = (
  //   <FilterItem>
  //     <DataEnrichmentSelect
  //       options={statusOptions}
  //       placeholder={'Status'}
  //       mode={'multiple'}
  //       value={filters.status}
  //       allowClear={true}
  //       onChange={updateStatus}
  //       tagRender={tagRender}
  //     />
  //   </FilterItem>
  // );

  // const typeFilterItem = (
  //   <FilterItem>
  //     <DataEnrichmentSelect
  //       options={typeOptions}
  //       placeholder={'Type'}
  //       mode={'multiple'}
  //       value={filters.type}
  //       allowClear={true}
  //       onChange={updateType}
  //       tagRender={tagRender}
  //     />
  //   </FilterItem>
  // );

  return (
    <FiltersContainer>
      <FiltersRow>
        {searchFilterItem}
        {dateFilterItem}
        {userFilterItem}
        {creditsRemaining != null && (
          <Tooltip title={`Renews in ${getDaysUntilEndOfMonth()} days`}>
            <CreditToken>
              <BoldSpan>{formatNumber(creditsRemaining)}</BoldSpan>
              <span>matches remaining</span>
            </CreditToken>
          </Tooltip>
        )}
      </FiltersRow>
    </FiltersContainer>
  );
}
